import { render, staticRenderFns } from "./breadRole.vue?vue&type=template&id=70cbacb6&scoped=true"
import script from "./breadRole.vue?vue&type=script&lang=js"
export * from "./breadRole.vue?vue&type=script&lang=js"
import style0 from "./breadRole.vue?vue&type=style&index=0&id=70cbacb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cbacb6",
  null
  
)

export default component.exports